import { Input } from '@iwoca/orion';
import { useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import { phoneSchema } from './PhoneScreen.schema';
import { TMobileSignupForm } from '../../form/form';
import { useScreenValidation } from '../../form/validation/useScreenValidation';
import { StepLayout } from '../../StepLayout/StepLayout';

// DIT-688. Phone number. Reads/writes the shared mobile signup form store
// (DIT-664).
export const PhoneScreen = () => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<TMobileSignupForm>();
  const { validateAndContinue } = useScreenValidation(phoneSchema);

  return (
    <StepLayout
      stageTitle={t`Tell us about yourself`}
      heading={t`Your phone number`}
      subHeading={t`We’ll use your phone number to contact you about your application.`}
      onContinue={validateAndContinue}
    >
      <Input
        {...register('phoneNumber')}
        type="tel"
        label={t`Main phone number`}
        placeholder={t`e.g. 07700 900000`}
        className="fs-mask"
        error={errors.phoneNumber?.message}
      />
    </StepLayout>
  );
};
